module.exports = __webpack_public_path__ + "img/primary-loc.5a01d2ef.svg";